<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button type="primary" size="small" @click="myOption.restStartPage();getList();">刷新</el-button>
        </li>
        <li v-if="isSspUser">
          <span>所属广告主：</span>
          <el-select size="small" v-model="selectUser" filterable :filter-method="filteredAdvertiser" @visible-change="advertiserSelectVisibleChanged" @change="myOption.restStartPage();selectFun('user');">
            <el-option v-for="(item, index) in userData" :label="item.advertiserName" :value="item.advertiserId" :key="index" v-show="item.visible">
              <span style="float: left">{{ item.advertiserName }}</span>
              <span style="float: right; color: #8492a6; font-size: 11px;margin-left: 20px" v-if="item.advertiserName !== '全部'" >{{ item.advertiserId }}</span>
            </el-option>
          </el-select>
        </li>
        <li>
          <span>投放单元：</span>
          <el-select size="small" v-model="selectUnit" filterable :filter-method="filteredPutUnit" @visible-change="putUnitSelectVisibleChanged" @change="myOption.restStartPage();selectFun('unit');">
            <el-option v-for="(item, index) in unitData" :label="item.putUnitName" :value="item.putUnitId" :key="index" v-show="item.visible">
              <span style="float: left">{{ item.putUnitName }}</span>
              <span style="float: right; color: #8492a6; font-size: 11px;margin-left: 20px" v-if="item.putUnitName !== '全部'">{{ item.putUnitId }}</span>
            </el-option>
          </el-select>
        </li>
        <li>
          <span>投放创意：</span>
          <el-select size="small" v-model="selectIdea" filterable :filter-method="filteredIdea" @visible-change="ideaSelectVisibleChanged" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in ideaData" :label="item.ideaName" :value="item.ideaId" :key="index" v-show="item.visible">
              <span style="float: left">{{ item.ideaName }}</span>
              <span style="float: right; color: #8492a6; font-size: 11px;margin-left: 20px" v-if="item.ideaName !== '全部'">{{ item.ideaId }}</span>
            </el-option>
          </el-select>
        </li>
        <li>
          <span>出价类型：</span>
          <el-select size="small" v-model="selectType" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in [...myOption.selectNull, ...myOption.bidType]" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>日期：</span>
          <el-date-picker v-model="time" size="small" value-format="yyyyMMdd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false" :picker-options="expireTimeOption" @change="getList"></el-date-picker>
        </li>
        <li>
          <el-button type="primary" size="small" @click="setExport">导出</el-button>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="createDay" label="日期" min-width="120px" fixed="left" :key="1"></el-table-column>
        <el-table-column v-if="isSspUser" prop="advertiserName" label="广告主名称" min-width="200px" :key="2">
          <template slot-scope="scope">
            <div>{{scope.row.advertiserName}}</div>
            <div class="id-col" v-if="scope.row.advertiserId">ID: {{scope.row.advertiserId}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="putUnitName" label="投放单元名称" min-width="260px" :key="3">
          <template slot-scope="scope">
            <div>{{scope.row.putUnitName}}</div>
            <div class="id-col" v-if="scope.row.putUnitId">ID: {{scope.row.putUnitId}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="ideaName" label="投放创意名称" min-width="260px" :key="4">
          <template slot-scope="scope">
            <div>{{scope.row.ideaName}}</div>
            <div class="id-col" v-if="scope.row.ideaId">ID: {{scope.row.ideaId}}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="selectType !== ''" prop="bidType" label="出价类型" min-width="120px" :key="5"></el-table-column>
        <el-table-column prop="simulateBid" label="消耗（元）" min-width="120px" :key="6"></el-table-column>
        <el-table-column prop="bidNum" label="竞价量" min-width="120px" :key="7"></el-table-column>
        <el-table-column prop="showNum" label="展示量" min-width="120px" :key="8"></el-table-column>
        <el-table-column prop="clickNum" label="点击量" min-width="120px" :key="9"></el-table-column>
        <el-table-column prop="clickRatio" label="点击率(%)" min-width="120px" :key="10"></el-table-column>
        <el-table-column prop="cpm" label="预估CPM" min-width="120px" :key="11"></el-table-column>
        <el-table-column prop="cpc" label="预估CPC" min-width="120px" :key="12"></el-table-column>
        <el-table-column prop="activateNum" label="转化量" min-width="140px" :key="26"></el-table-column>
        <el-table-column prop="downStartNum" label="下载开始量" min-width="120px" :key="13"></el-table-column>
        <el-table-column prop="downFinishNum" label="下载完成量" min-width="120px" :key="14"></el-table-column>
        <el-table-column prop="installStartNum" label="安装开始量" min-width="120px" :key="15"></el-table-column>
        <el-table-column prop="installFinishNum" label="安装完成量" min-width="120px" :key="16"></el-table-column>
        <el-table-column prop="packageOpenNum" label="通过包名打开量" min-width="120px" :key="17"></el-table-column>
        <el-table-column prop="deepinkOpenNum" label="应用唤醒量" min-width="120px" :key="18"></el-table-column>
        <el-table-column prop="playStartNum" label="播放开始量" min-width="120px" :key="19"></el-table-column>
        <el-table-column prop="playInterruptNum" label="播放中断量" min-width="120px" :key="20"></el-table-column>
        <el-table-column prop="playEndNum" label="播放结束量" min-width="120px" :key="21"></el-table-column>
        <el-table-column prop="adSkipNum" label="广告跳过量" min-width="120px" :key="22"></el-table-column>
        <el-table-column prop="adCloseNum" label="广告被关闭量" min-width="120px" :key="23"></el-table-column>
        <el-table-column prop="fullScreenNum" label="全屏播放量" min-width="120px" :key="24"></el-table-column>
        <el-table-column prop="startCardNum" label="点击预览图播放量" min-width="140px" :key="25"></el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: false,
      thisModule: [],
      tableData: [{}],
      userData: [],
      unitData: [],
      ideaData: [],
      selectUser: '',
      selectUnit: '',
      selectIdea: '',
      selectType: '',
      time: [this.myOption.getNowDateYMD(), this.myOption.getNowDateYMD()],
      expireTimeOption: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    // 缓存模块配置
    this.thisModule = this.myOption.requestModule.chart.children.idea
    // 判断是否为媒体主
    if (this.isSspUser) {
      this.getAdOwnerList().then(() => {
        this.getUnitList().then(() => {
          this.getIdeaList().then(() => {
            this.getList()
          })
        })
      })
    } else {
      this.getUnitList().then(() => {
        this.getIdeaList().then(() => {
          this.getList()
        })
      })
    }
  },
  methods: {
    // 获取广告主列表
    getAdOwnerList () {
      this.isLoading = true
      return new Promise((resolve) => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.id
          },
          url: this.myOption.requestUrl + this.thisModule.user,
          data: this.qs.stringify({
            startPage: 1,
            pageSize: this.myOption.pageSize.max
          })
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            let data = res.data.data.data
            let arr = []
            for (let val of data) {
              arr.push(val.advertiserId)
            }
            data.unshift({advertiserName: '全部', advertiserId: arr.join(',')})
            this.userData = data
            this.selectUser = this.userData[0].advertiserId
            resolve && resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
          this.isLoading = false
        })
      })
    },
    // 获取投放单元列表
    getUnitList () {
      this.isLoading = true
      return new Promise((resolve) => {
        let param = {
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        }
        if (this.isSspUser) {
          param.isSspUser = 1
          param.advertiserId = this.selectUser
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.id
          },
          url: this.myOption.requestUrl + this.thisModule.unit,
          data: this.qs.stringify(param)
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            let data = res.data.data.data
            let arr = []
            for (let val of data) {
              arr.push(val.putUnitId)
            }
            data.unshift({putUnitName: '全部', putUnitId: arr.join(',')})
            this.unitData = data
            this.selectUnit = this.unitData[0].putUnitId
            resolve && resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
          this.isLoading = false
        })
      })
    },
    // 获取投放创意列表
    getIdeaList () {
      return new Promise((resolve) => {
        let param = {
          putUnitId: this.selectUnit,
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        }
        if (this.isSspUser) {
          param.isSspUser = 1
          param.advertiserId = this.selectUser
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.id
          },
          url: this.myOption.requestUrl + this.thisModule.idea,
          data: this.qs.stringify(param)
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            let data = res.data.data.data
            let arr = []
            for (let val of data) {
              arr.push(val.ideaId)
            }
            data.unshift({ideaName: '全部', ideaId: arr.join(',')})
            this.ideaData = data
            this.setAllIdeaVisible()
            this.selectIdea = this.ideaData[0].ideaId
            resolve && resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
          this.isLoading = false
        })
      })
    },
    // 列表下拉框重置
    selectFun (type) {
      if (type) {
        if (type === 'user') {
          this.getUnitList().then(() => {
            this.getIdeaList().then(() => {
              this.getList()
            })
          })
        } if (type === 'unit') {
          this.getIdeaList().then(() => {
            this.getList()
          })
        }
      }
    },

    filteredPutUnit (inputValue) {
      if (inputValue) {
        this.unitData.forEach(putUnit => {
          this.$set(putUnit, 'visible', putUnit.putUnitName.toLowerCase().includes(inputValue.toLowerCase()) || String(putUnit.putUnitId) === inputValue)
        })
      } else {
        this.setAllPutUnitVisible()
      }
    },
    putUnitSelectVisibleChanged (visible) {
      if (visible) this.setAllPutUnitVisible()
    },
    setAllPutUnitVisible () {
      this.unitData.forEach(putUnit => {
        this.$set(putUnit, 'visible', true)
      })
    },

    filteredAdvertiser (inputValue) {
      if (inputValue) {
        this.userData.forEach(advertiser => {
          this.$set(advertiser, 'visible', advertiser.advertiserName.toLowerCase().includes(inputValue.toLowerCase()) || String(advertiser.advertiserId) === inputValue)
        })
      } else {
        this.setAllAdvertiserVisible()
      }
    },
    advertiserSelectVisibleChanged (visible) {
      if (visible) this.setAllAdvertiserVisible()
    },
    setAllAdvertiserVisible () {
      this.userData.forEach(advertiser => {
        this.$set(advertiser, 'visible', true)
      })
    },

    filteredIdea (inputValue) {
      if (inputValue) {
        this.ideaData.forEach(idea => {
          this.$set(idea, 'visible', idea.ideaName.toLowerCase().includes(inputValue.toLowerCase()) || String(idea.ideaId) === inputValue)
        })
      } else {
        this.setAllIdeaVisible()
      }
    },
    ideaSelectVisibleChanged (visible) {
      if (visible) this.setAllIdeaVisible()
    },
    setAllIdeaVisible () {
      this.ideaData.forEach(idea => {
        this.$set(idea, 'visible', true)
      })
    },

    // 获取列表
    getList () {
      let param = {
        putUnitId: this.selectUnit,
        ideaId: this.selectIdea,
        startDay: this.time[0],
        endDay: this.time[1],
        bidType: this.selectType,
        startPage: this.$store.state.user.currentPage,
        pageSize: this.$store.state.user.pageSize
      }
      if (this.isSspUser) {
        param.advertiserId = this.selectUser
        param.isSspUser = 1
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.api,
        data: this.qs.stringify(param)
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            let time = val.createDay
            if (time !== '总计') {
              val.createDay = this.myOption.getTimeStampDate(time)
              val.bidType = this.myOption.getIdData('bidType', val.bidType, 'name')
            }
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 导出
    setExport () {
      this.$axios({
        method: 'post',
        responseType: 'arraybuffer',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.export,
        data: this.qs.stringify({
          putUnitId: this.selectUnit,
          ideaId: this.selectIdea,
          startDay: this.time[0],
          endDay: this.time[1],
          bidType: this.selectType,
          advertiserId: this.selectUser,
          isSspUser: this.isSspUser * 1
        })
      }).then(res => {
        var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        var objectUrl = URL.createObjectURL(blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = objectUrl
        a.download = '创意报表'
        a.click()
        document.body.removeChild(a)
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
  .List-headr>li{
    margin-top: 10px;
  }
  .id-col{
    color: #bbb;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/idea/Chart.vue